var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"loading","hide-header":"","hide-footer":"","centered":"","no-close-on-backdrop":""}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('span',[_vm._v("در حال بارگذاری ...لطفا کمی صبر نمایید")]),_c('b-spinner',{attrs:{"type":"grow","label":"Loading..."}})],1)]),_c('Order',{attrs:{"role":"Manager"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }